import {Routes} from "@angular/router";
import {ROUTES} from "@coreConstant";
import {authGuard, productTypeGuard} from "./core/guards/auth.guard";
import {LayoutComponent} from "./core/components/layout/layout.component";

export const routes: Routes = [
  {
    path: ROUTES.CHECKOUT,
    loadChildren: () => import('./features/account/checkout/checkout.routes').then((r) => r.routes),
    canActivate: [authGuard]
  },
  {
    path: ROUTES.GUEST_CHECKOUT + '/' + ROUTES.PAYMENT + '/' + ROUTES.EXPORT_ID + '/' + ROUTES.CHECKOUT_PAYMENT_TYPE,
    loadComponent: () => import('./features/account/checkout/checkout.component').then(c => c.CheckoutComponent)
  },
  {
    path: ROUTES.PAYMENT + '/' + ROUTES.PAYMENT_RESPONSE,
    loadComponent: () => import('./features/payment-response/payment-response.component').then(c => c.PaymentResponseComponent)
  },
  {
    path: ROUTES.GUEST + '/' + ROUTES.CARRIER + '/' + ROUTES.EXPORT_ID + '/' + ROUTES.STATUS,
    loadComponent: () => import('./features/guest-carrier/guest-carrier.component').then(c => c.GuestCarrierComponent)
  },
  {
    path: ROUTES.QUOTE_INVOICE + '/' + ROUTES.EXPORT_ID + '/' + ROUTES.PAYMENT_RECEIPT_ID,
    loadComponent: () => import('./features/live-link/live-link.component').then(comp => comp.LiveLinkComponent)
  },
  {
    path: ROUTES.QUOTE_INVOICE + '/' + ROUTES.EXPORT_ID,
    loadComponent: () => import('./features/live-link/live-link.component').then(comp => comp.LiveLinkComponent)
  },
  {
    path: ROUTES.TRACK_ORDER + '/' + ROUTES.TRACK_ID,
    loadComponent: () => import('./features/live-link/live-link.component').then(comp => comp.LiveLinkComponent)
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: ROUTES.HOME,
        loadComponent: () => import('./features/home/home.component').then(comp => comp.HomeComponent)
      },
      {
        path: ROUTES.RESET_PASSWORD,
        loadComponent: () => import('./features/home/home.component').then(comp => comp.HomeComponent),
        canActivate: [authGuard]
      },
      {
        path: ROUTES.LOGIN,
        loadComponent: () => import('./features/home/home.component').then(comp => comp.HomeComponent),
        canActivate: [authGuard]
      },
      {
        path: ROUTES.REGISTER,
        loadComponent: () => import('./features/home/home.component').then(comp => comp.HomeComponent),
        canActivate: [authGuard]
      },
      {
        path: ROUTES.RESOURCE_HUB,
        loadComponent: () => import('./features/resource-hub/resource-hub.component').then(comp => comp.ResourceHubComponent)
      },
      {
        path: ROUTES.OUR_STORY,
        loadComponent: () => import('./features/our-story/our-story.component').then(comp => comp.OurStoryComponent),
        data: {showBanner: true}
      },
      {
        path: ROUTES.FEATURE_PROJECTS.ROOT,
        loadComponent: () => import('./features/feature-projects/feature-projects-list/feature-projects-list.component').then(comp => comp.FeatureProjectsListComponent),
        data: {showBanner: true}
      },
      {
        path: ROUTES.FEATURE_PROJECTS.ROOT + '/' + ROUTES.FEATURE_PROJECTS.SLUG,
        loadComponent: () => import('./features/feature-projects/feature-project-details/feature-project-details.component').then((comp) => comp.FeatureProjectDetailsComponent),
        data: {showBanner: true}
      },
      {
        path: ROUTES.BLOGS.ROOT,
        loadComponent: () => import('./features/blogs/blog-list/blogs.component').then(comp => comp.BlogsComponent),
        data: {showBanner: true}
      },
      {
        path: ROUTES.BLOGS.ROOT + '/' + ROUTES.BLOGS.SLUG,
        loadComponent: () => import('./features/blogs/blog-details/blog-details.component').then(comp => comp.BlogDetailsComponent),
        data: {showBanner: true}
      },
      {
        path: ROUTES.TILES_FOR_SMILES,
        loadComponent: () => import('./features/tiles-for-smiles/tiles-for-smiles.component').then(comp => comp.TilesForSmilesComponent),
        data: {showBanner: true}
      },
      {
        path: ROUTES.PRICE_LIST,
        loadComponent: () => import('./features/price-list/price-list.component').then(comp => comp.PriceListComponent),
        // canActivate: [authGuard]
      },
      {
        path: ROUTES.GATHER_COMMITMENT,
        loadComponent: () => import('./features/gather-commitment/gather-commitment.component').then(comp => comp.GatherCommitmentComponent),
        // canActivate: [authGuard]
        data: {showBanner: true}
      },
      {
        path: ROUTES.CONTACT,
        loadComponent: () => import('./features/contact/contact.component').then(comp => comp.ContactComponent),
        data: {showBanner: true}
      },
      {
        path: ROUTES.SAMPLE_REQUEST,
        loadComponent: () => import('./features/sample-request/sample-request.component').then(comp => comp.SampleRequestComponent),
        data: {showBanner: true}
      },
      {
        path: ROUTES.FAQ,
        loadComponent: () => import('./features/frequently-asked-questions/frequently-asked-questions.component').then(comp => comp.FrequentlyAskedQuestionsComponent)
      },
      {
        path: ROUTES.FAQ + '/' + ROUTES.FAQ_SLUG,
        loadComponent: () => import('./features/frequently-asked-questions/frequently-asked-questions.component')
          .then(m => m.FrequentlyAskedQuestionsComponent)
      },
      {
        path: ROUTES.TERMS_AND_CONDITIONS,
        loadComponent: () => import('./features/terms-and-conditions/terms-and-conditions.component').then(comp => comp.TermsAndConditionsComponent)
      },
      {
        path: ROUTES.PRIVACY_POLICY,
        loadComponent: () => import('./features/privacy-policy/privacy-policy.component').then(comp => comp.PrivacyPolicyComponent)
      },
      {
        path: ROUTES.STORE_LOCATOR,
        loadComponent: () => import('./features/store-locator/store-locator.component').then(comp => comp.StoreLocatorComponent)
      },
      {
        path: ROUTES.RESOURCE_HUB,
        loadComponent: () => import('./features/resource-hub/resource-hub.component').then(comp => comp.ResourceHubComponent)
      },
      {
        path: ROUTES.ACCOUNT.ROOT,
        loadChildren: () => import('./features/account/account.routes').then(r => r.routes),
        canActivate: [authGuard]
      },
      {
        path: ROUTES.SEARCH,
        loadComponent: () => import('./features/search-results/search-results.component').then(comp => comp.SearchResultsComponent)
      },
      {
        path: ROUTES.OUTLET.ROOT,
        loadComponent: () => import('./features/outlet/outlet.component').then(comp => comp.OutletComponent)
      },
      {
        path: ROUTES.OUTLET.ROOT + '/' + ROUTES.OUTLET.PRODUCT_TYPE,
        loadComponent: () => import('./features/outlet/outlet-category-list/outlet-category-list.component').then(comp => comp.OutletCategoryListComponent)
      },
      {
        path: ROUTES.PAGE_NOT_FOUND,
        loadComponent: () => import('./features/page-not-found/page-not-found.component').then(comp => comp.PageNotFoundComponent),
      },
      {
        path: ROUTES.OUTLET.ROOT + '/' + ROUTES.PRODUCT.PRODUCT_TYPE + '/' + ROUTES.PRODUCT.COLLECTION_NAME + '/' + ROUTES.PRODUCT.CATEGORY_NAME + '/' + ROUTES.PRODUCT.FAMILY_FINISH_NAME,
        loadComponent: () => import('./features/products/product-details/product-details.component').then((comp) => comp.ProductDetailsComponent),
        data: {path: ROUTES.OUTLET.ROOT}
      },
      {
        path: ROUTES.OUTLET.ROOT + '/' + ROUTES.PRODUCT.PRODUCT_TYPE + '/' + ROUTES.PRODUCT.COLLECTION_NAME + '/' + ROUTES.PRODUCT.CATEGORY_NAME + '/' + ROUTES.PRODUCT.FAMILY_FINISH_NAME + '/' + ROUTES.PRODUCT.PRODUCT_SKU_CODE,
        loadComponent: () => import('./features/products/product-details/product-details.component').then((comp) => comp.ProductDetailsComponent),
        data: {path: ROUTES.OUTLET.ROOT}
      },
      {
        path: ROUTES.PAGE_NOT_FOUND,
        loadComponent: () => import('./features/page-not-found/page-not-found.component').then(comp => comp.PageNotFoundComponent)
      },
      {
        path: ROUTES.QUOTE_EXAMPLE,
        loadComponent: () => import('./features/sample-quote/sample-quote.component').then(comp => comp.SampleQuoteComponent)
      },
      {
        path: ROUTES.PRODUCT.PRODUCT_TYPE,
        loadComponent: () => import('./features/products/product-types/product-types.component').then((comp) => comp.ProductTypesComponent),
        pathMatch: 'full',
        canActivate: [productTypeGuard],
        data: {showBanner: true}
      },
      {
        path: ROUTES.PRODUCT.PRODUCT_TYPE + '/' + ROUTES.PRODUCT.COLLECTION_NAME,
        loadComponent: () => import('./features/products/product-types-list/product-types-list.component').then((comp) => comp.ProductTypesListComponent),
        pathMatch: 'full',
        data: {showBanner: true}
      },
      {
        path: ROUTES.PRODUCT.PRODUCT_TYPE + '/' + ROUTES.PRODUCT.COLLECTION_NAME + '/' + ROUTES.PRODUCT.CATEGORY_NAME,
        loadComponent: () => import('./features/products/product-types-list/product-types-list.component').then((comp) => comp.ProductTypesListComponent),
        pathMatch: 'full'
      },
      {
        path: ROUTES.PRODUCT.PRODUCT_TYPE + '/' + ROUTES.PRODUCT.COLLECTION_NAME + '/' + ROUTES.PRODUCT.CATEGORY_NAME + '/' + ROUTES.PRODUCT.FAMILY_FINISH_NAME,
        loadComponent: () => import('./features/products/product-details/product-details.component').then((comp) => comp.ProductDetailsComponent),
      },
      {
        path: ROUTES.PRODUCT.PRODUCT_TYPE + '/' + ROUTES.PRODUCT.COLLECTION_NAME + '/' + ROUTES.PRODUCT.CATEGORY_NAME + '/' + ROUTES.PRODUCT.FAMILY_FINISH_NAME + '/' + ROUTES.PRODUCT.PRODUCT_SKU_CODE,
        loadComponent: () => import('./features/products/product-details/product-details.component').then((comp) => comp.ProductDetailsComponent),
      }
    ]
  },
  {
    path: ROUTES.NOT_FOUND,
    loadComponent: () => import('./features/page-not-found/page-not-found.component').then(comp => comp.PageNotFoundComponent)
  },
];
